// Navigation domains for the frontend application
export enum APP_DOMAINS {
  CONVERSATIONS = 'conversations',
  COLLAB = 'collab',
  CAMPAIGNS = 'campaigns',
  TRAINING = 'training',
  STATS = 'stats',
  SETTINGS = 'settings',
  AGENTS = 'agents',
  BILLING = 'billing',
  TEAMS = 'teams',
  INTEGRATIONS = 'integrations',
  STORE = 'store',
  INVENTORY = 'inventory',
  SCHEDULE = 'schedule',
  CUSTOMERS = 'customers',
  FORMS = 'forms',
}

// User roles for route permissions
export enum OWNER_ROLES {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  COLLABORATOR = 'COLLABORATOR',
}

// Route permissions interface
export interface APP_ROUTES_PERMISSIONS {
  [APP_DOMAINS.CONVERSATIONS]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.COLLAB]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.CAMPAIGNS]: {
    roles: OWNER_ROLES[];
  };

  [APP_DOMAINS.BILLING]: {
    roles: OWNER_ROLES[];
  };

  [APP_DOMAINS.TEAMS]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.INTEGRATIONS]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.STORE]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.INVENTORY]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.TRAINING]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.STATS]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.SETTINGS]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.SCHEDULE]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.CUSTOMERS]: {
    roles: OWNER_ROLES[];
  };
  [APP_DOMAINS.FORMS]: {
    roles: OWNER_ROLES[];
  };
}

// Route permissions configuration
export const APP_ROUTES_PERMISSIONS: APP_ROUTES_PERMISSIONS = {
  [APP_DOMAINS.CONVERSATIONS]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR, OWNER_ROLES.COLLABORATOR],
  },
  [APP_DOMAINS.COLLAB]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR, OWNER_ROLES.COLLABORATOR],
  },
  [APP_DOMAINS.CAMPAIGNS]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR],
  },
  [APP_DOMAINS.TRAINING]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR],
  },

  [APP_DOMAINS.BILLING]: {
    roles: [OWNER_ROLES.ADMIN],
  },

  [APP_DOMAINS.TEAMS]: {
    roles: [OWNER_ROLES.ADMIN],
  },
  [APP_DOMAINS.STORE]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR, OWNER_ROLES.COLLABORATOR],
  },
  [APP_DOMAINS.INVENTORY]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR],
  },
  [APP_DOMAINS.INTEGRATIONS]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR],
  },
  [APP_DOMAINS.STATS]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR],
  },
  [APP_DOMAINS.SETTINGS]: {
    roles: [OWNER_ROLES.ADMIN],
  },
  [APP_DOMAINS.SCHEDULE]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR, OWNER_ROLES.COLLABORATOR],
  },
  [APP_DOMAINS.CUSTOMERS]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR, OWNER_ROLES.COLLABORATOR],
  },
  [APP_DOMAINS.FORMS]: {
    roles: [OWNER_ROLES.ADMIN, OWNER_ROLES.EDITOR, OWNER_ROLES.COLLABORATOR],
  },
};
